import axios, { type AxiosError, type AxiosRequestConfig } from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://sonar.logic.io/wcwx2';

export const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add a request interceptor to add cache-busting
api.interceptors.request.use(config => {
  const existingParams = config.params as Record<string, unknown> | undefined;
  config.params = {
    ...existingParams,
    _t: new Date().getTime(),
  };
  return config;
});

export const handleApiError = (error: unknown, context: string): void => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError;
    console.error(`API Error [${context}]:`, {
      message: axiosError.message,
      status: axiosError.response?.status,
      data: axiosError.response?.data,
    });
  } else {
    console.error(`Error [${context}]:`, error);
  }
};

/**
 * Typed GET request helper with automatic error handling
 */
export async function fetchData<T>(
  endpoint: string,
  context: string,
  config?: AxiosRequestConfig
): Promise<T | null> {
  try {
    const response = await api.get<T>(endpoint, config);
    return response.data;
  } catch (error) {
    handleApiError(error, context);
    return null;
  }
}

/**
 * Typed GET request helper that throws on error (for when caller handles errors)
 */
export async function fetchDataOrThrow<T>(
  endpoint: string,
  config?: AxiosRequestConfig
): Promise<T> {
  const response = await api.get<T>(endpoint, config);
  return response.data;
}
